import React from "react";
import { Container } from "react-bootstrap";

export default function About() {
  return (
    <Container className="py-5">
      <h2>Über uns</h2>
      <p>
        Willkommen bei Fluybuy! Wir sind ein Studententeam, das die Suche nach
        günstigen Last-Minute-Flügen revolutionieren möchte.
      </p>
      {/* …weitere Inhalte… */}
    </Container>
  );
}
